import { FullPageCard } from "../FullPageCard/FullPageCard";

export const GlobalNotAuthorized = () => {
  return (
    <div className="flex w-full">
      <div className="flex w-full">
        <FullPageCard
          title="Not authorized"
          backButtonLink="/"
          backButtonTitle="Back to home"
        >
          <div>
            {`You do not have access to view this page. Please contact your administrator.`}
          </div>
        </FullPageCard>
      </div>
    </div>
  );
};
